import { render, staticRenderFns } from "./confirmation-letter.html?vue&type=template&id=9f0a7f4c&scoped=true&external"
import script from "./confirmation-letter.js?vue&type=script&lang=js&external"
export * from "./confirmation-letter.js?vue&type=script&lang=js&external"
import style0 from "./confirmation-letter.scss?vue&type=style&index=0&id=9f0a7f4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a7f4c",
  null
  
)

export default component.exports